export const BANNER_LIST_INDEX = 4;
